
import { Component, Vue } from "vue-property-decorator"
import { Getter, namespace, State } from "vuex-class"

import { CurrentUser } from "@/types/user"

import PageWrapper from "@/components/New/Page/PageWrapper.vue"

import ConfigMenu from "@/components/Config/ConfigMenu.vue"

import { TenantFeatures } from "@/types/tenantFeatures"
import { DataSource } from "@/types"
import { Folder, FolderType } from "@/types/folder"
import api from "@/services/api"

const setup = namespace("setup")

@Component({
	components: {
		"page": PageWrapper,
		"config-menu": ConfigMenu
	}
})
export default class Configuration extends Vue {
	@State
	me!: CurrentUser | null

	@Getter getIsFeatureEnabled!: (feature: TenantFeatures) => boolean
	@State tenantEnabledFeatures!: { [key: string]: boolean }

	@setup.Getter("getDataSources")
	public dataSources!: DataSource[] | null

	@setup.Action
	public loadTeams!: () => Promise<void>

	@setup.Action
	public loadDataSources!: () => Promise<void>

	@setup.Action
	public loadDefinitions!: () => Promise<void>

	public loading: boolean = true

	dataSourceFolders: Folder[] = []

	refreshSources = async () => this.loadDataSources()

	public async mounted () {
		await Promise.all([
			this.loadTeams(),
			this.loadDataSources(),
			this.loadDefinitions(),
			this.loadSourceFolders()
		])

		this.loading = false
	}

	get dataSourceFoldersFeatureIsEnabled (): boolean {
		return this.tenantEnabledFeatures && this.tenantEnabledFeatures[TenantFeatures.DataSourceFolders]
	}

	private async loadSourceFolders (reloadSourcesAlso: boolean = false): Promise<void> {
		if (this.dataSourceFoldersFeatureIsEnabled) {
			this.dataSourceFolders = await api.foldersGet(FolderType.DataSource)
			if (reloadSourcesAlso) {
				await this.refreshSources()
			}
		}
	}
}

